module.exports = __webpack_public_path__ + "static/media/S1N5.5d2cc3dd.svg";